<template>
  <div
    class="c-search-input"
  >
    <div
      class="c-search-input__prefix"
    >
      🔍
    </div>
    <input
      ref="inputRef"
      class="c-search-input__input"
      v-model="input"
      type="text"
      :placeholder="placeholder"
      @keyup.enter="$emit('search', input)"
    >
    <div
      class="c-search-input__close"
      v-if="input?.length > 0"
      @click="onClear"
    >
      <Icon
        name="close-l-2"
      />
    </div>
    <div
      class="c-search-input__suffix"
      @click="$emit('search', input)"
    >
      <Icon name="search-l" />
    </div>
  </div>
</template>

<script setup>
import { Icon } from '../Icon'

const inputRef = useTemplateRef('inputRef')
const input = defineModel({ type: String })

const props = defineProps({
  placeholder: {
    type: String,
    default: null
  },
  disabled: Boolean
})

const emit = defineEmits(['search', 'clear'])

const onClear = () => {
  if (props.disabled) return
  input.value = ''
  nextTick(() => {
    emit('clear', input.value)
  })
}

defineExpose({
  focus () {
    inputRef.value?.focus()
  }
})
</script>

<style lang="less">
.c-search-input {
  display: flex;
  align-items: center;
  padding: 4px;
  gap: 4px;
  border-radius: 20px;
  background-color: #FFFFFF;
  border: 1px solid #EBF1F5;
  width: 100%;

  &:has(.c-search-input__input:focus) {
    border-color: #232323;
  }

  &__prefix {
    padding-left: 12px;
    font-size: 12px;
  }

  &__input {
    height: 100%;
    width: 100%;
    border: none;
    outline: none;
    font-size: 12px;
    font-family: mon-500;
    background-color: inherit;

    &::placeholder {
      color: #B2B7C2;
    }
  }

  &__close {
    flex-shrink: 0;
    margin-right: 4px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    cursor: pointer;
    background-color: #F5F5F5;
  }

  &__suffix {
    flex-shrink: 0;
    padding: 4px 12px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    transition: all .3s;
    cursor: pointer;
    background-color: #232323;
    color: white;

    @media (hover: hover) {
      background-color: inherit;
      color: inherit;

      &:hover {
        background-color: #232323;
        color: white;
      }
    }
  }
}
</style>
